/* eslint-disable max-len */
// Local imports
import Stack from '@mui/material/Stack';
import { Box, Button, List, ListItem, Typography } from '@mui/material';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import VotingScoreFormula from 'components/common/VotingScoreFormula';

import voting_box_pics from 'assets/voting_out_of_date_v3.png';
import { Link } from 'react-router-dom';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Paper from '@mui/material/Paper';

// Component definition
function HomePage() {
  return (
    <Stack fontFamily={'Arial'}
      spacing={4}
      pt={2} pl={{xs: 2, sx: 2, sm: 2, md: 8, lg: 10}} pr={{xs: 2, sx: 2, sm: 2, md: 8, lg: 10}}
      justifyContent={'center'} textAlign={'center'} width={'100%'}>

      <Box sx={{
        width: {
          xs: 'calc(100% + 32px)',
          sx: 'calc(100% + 32px)',
          sm: 'calc(100% + 32px)',
          md: 'calc(100% + 128px)',
          lg: 'calc(100% + 160px)',
        },
        marginTop: '-16px',
        marginLeft: {
          xs: '-16px',
          sx: '-16px',
          sm: '-16px',
          md: '-64px',
          lg: '-80px',
        }}}
        component="img" src={voting_box_pics}>

  </Box>
  <Paper style={{ padding: '20px', marginTop: '20px' }}>
        <Typography variant="h5" gutterBottom>
          Introducing the Balanced Voting Model
        </Typography>
        <Typography paragraph>
          This new model aims to enable citizens at all levels (community, national) to actively participate in approving initiatives, solutions, investments, and development ideas proposed by their elected representatives through an online platform.
        </Typography>

        <Typography paragraph>
          For example, in a local government, any elected representative, regardless of political background or position, can put forward proposals. These can be critiqued or supported by their colleagues in the form of opinion articles published on the online voting platform.
        </Typography>

        <Typography paragraph>
          Following this, local residents can acquaint themselves with the topics up for vote, along with the critical and supportive views within the government. By familiarizing themselves with these pro and con opinions, the value of their votes increases (critical to ensure the masses aren&apos;t blindly or ignorantly influencing current affairs).
        </Typography>
        <Typography variant="h3" component={'div'} textAlign={'center'}>
      <EmojiPeopleIcon fontSize='inherit' color='error' />≠<EmojiPeopleIcon fontSize='inherit' color='success' />
      <br/>
  </Typography>

        <Typography variant="h6">Goals of the Model:</Typography>
        <List sx={{ listStyle: 'decimal', pl: 4 }}>
          <ListItem sx={{ display: 'list-item' }}>Eliminate the unipolar power structures at local and national levels, ensuring those in opposition or minority also have significant influence.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Transform voting from a cumbersome, manipulable process into a more reliable and trustworthy institution.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Encourage productive and meaningful discourse between the masses and politicians, focusing on specific issues.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Ensure that politicians in the majority or with significant influence also adhere to the will of the people as expressed through the online balanced voting platform.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Empower individuals who are disillusioned with politics to actively participate, even without party support or backing.</ListItem>
        </List>

        <Typography paragraph>
          Introducing this model is another question altogether. It&apos;s well-known that the current government has cemented its position. Therefore, changing the legal and legislative framework to its disadvantage is not feasible.
        </Typography>
        <Typography variant="h3" component={'div'} textAlign={'center'}>
      <Stack direction="row" spacing={3} justifyContent={'center'}>
        <Stack alignContent={'center'} textAlign={'center'}>
          <span>
          <EmojiPeopleIcon fontSize='inherit' color='error' />
          </span>
          <span style={{fontSize: '14px'}}>
            <VotingScoreFormula />
          </span>
        </Stack>
        <Typography fontSize='inherit' >
        &gt;
        </Typography>
        <Typography fontSize='inherit' >
          <EmojiPeopleIcon fontSize='inherit' color='success' />
          <EmojiPeopleIcon fontSize='inherit' color='success' />
          <EmojiPeopleIcon fontSize='inherit' color='success' />
          <EmojiPeopleIcon fontSize='inherit' color='success' />
        </Typography>
      </Stack>
    </Typography>
    <br/>
        <Typography variant="h6">Implementation:</Typography>
        <List sx={{ listStyle: 'decimal', pl: 4 }}>
          <ListItem sx={{ display: 'list-item' }}>The balanced voting online platform can be implemented with some IT expertise and minimal infrastructural investment.</ListItem>
          <ListItem sx={{ display: 'list-item' }}>Initially, partnering with one or two smaller city councils or a promising candidate who would introduce and make this platform accessible to the local population is sufficient.</ListItem>
        </List>

        <Typography paragraph>
          Creating a precedent in practice, showing people that there is another way, an alternative where politicians don&apos;t have to hate and undermine each other but can instead think, plan, and build the country together, seeking and implementing good solutions in a spirit of transparent communication and cooperative collaboration with the people, could, I believe, lead to change on a national level.
        </Typography>
        <Typography paragraph>
          Seize the opportunity to be a pioneer in transforming democratic engagement with our innovative online balanced voting platform, a groundbreaking approach inviting investment to shape a more inclusive and participatory future in governance.
    </Typography>
    <Typography paragraph>
    {'Contact me:'}&nbsp;
    <span style={{color: 'blue', fontWeight: 'bold'}}>{'hmartonsandor@gmail.com'}</span>
    </Typography>
      </Paper>
    <h4 style={{fontSize: 'x-large', fontWeight: 'normal'}}>{'See below the more detailed explanation with examples'}</h4>



      <Typography variant="body2" color="text.secondary" component={'div'} textAlign={'left'}>
      <Typography variant="body1" fontWeight={'bold'} component={'div'} textAlign={'left'}>
      {'The Balanced Voting System guarantees:'}
      </Typography>
      <br/>
      <ul style={{textAlign: 'left'}}>
      <li>{'The voter is sufficiently informed about the subject and the issues to be voted on'}</li>
      <li>{'The voter is aware of several different pro and con positions on the vote before casting his/her vote.'}</li>
      <li>{'The value of the voter\'s vote will be determined by the extent to which he or she is aware of different expert critical content surrounding the subject of the vote.'}</li>
      <li>{'In addition, other factors can increase/decrease the value of a vote, such as: location, education, level of involvement (gender, age, religion).'}</li>
      <li>{'Practice continuous (weekly or even daily) control over the activities of decision-makers in the form of online voting.'}</li>
      </ul>
      <br/>
      {'The aim is for citizens to be truly equal partners, even bosses, to their politicians, but above all to be governed by reason and common sense.'}
    </Typography>

    <Typography variant="body2" component={'div'} textAlign={'left'}>
    <Typography variant="body1" color="text.secondary"  fontWeight={'bold'} component={'div'} textAlign={'left'}>
    {'The vote value calculated the following way:'}
    </Typography>
    <br/>
    <h4>Formula:</h4>
    <br/><span style={{color: 'green', fontWeight: 'bold'}}>p</span> = number of read <span style={{color: 'green', fontWeight: 'bold'}}>pro</span> articles (📝)
    <br/><span style={{color: 'red', fontWeight: 'bold'}}>c</span> = number of read <span style={{color: 'red', fontWeight: 'bold'}}>con</span> articles (📝)
    <br/><br/>
    5 * (<span style={{color: 'green', fontWeight: 'bold'}}>p</span> + <span style={{color: 'red', fontWeight: 'bold'}}>c</span>) + 25 * ((<span style={{color: 'green', fontWeight: 'bold'}}>p</span> + <span style={{color: 'red', fontWeight: 'bold'}}>c</span> - |<span style={{color: 'green', fontWeight: 'bold'}}>p</span> - <span style={{color: 'red', fontWeight: 'bold'}}>c</span>|) / 2) = your voting score 🗳
    <br/><br/>
    <h4>Examples:</h4>
    <br/>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Pro article (n read)</TableCell>
            <TableCell>Con article (m read)</TableCell>
            <TableCell>Score calculation</TableCell>
            <TableCell>Voting score</TableCell>
          </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
            <TableCell>1</TableCell>
            <TableCell>1</TableCell>
            <TableCell>2 * 5 + 5 * 5 =</TableCell>
            <TableCell>35</TableCell>
        </TableRow>
        <TableRow>
            <TableCell>3</TableCell>
            <TableCell>0</TableCell>
            <TableCell>3 * 5=</TableCell>
            <TableCell>15</TableCell>
        </TableRow>
        <TableRow>
            <TableCell>0</TableCell>
            <TableCell>2</TableCell>
            <TableCell>2 * 5=</TableCell>
            <TableCell>10</TableCell>
        </TableRow>
        <TableRow>
            <TableCell>2</TableCell>
            <TableCell>2</TableCell>
            <TableCell>4 * 5 + 2 * 25=</TableCell>
            <TableCell>70</TableCell>
        </TableRow>
        <TableRow>
            <TableCell>3</TableCell>
            <TableCell>1</TableCell>
            <TableCell>4 * 5 + 1 * 25=</TableCell>
            <TableCell>45</TableCell>
        </TableRow>
      </TableBody>
      </Table>
    </TableContainer>
    <>
  </>
  <br/>
  <br/>
  <Typography variant="body1" color="text.secondary"  fontWeight={'bold'} component={'div'} textAlign={'left'}>
    {'What is also important about this formula context:'}
    </Typography>
    <br/>
    <ul style={{textAlign: 'left'}}>
      <li>Pro and contra articles can be published / assigned to one specific voting topic only</li>
      <li>The reading and understanding of these articles are validated by quiz</li>
      <li>A citizen can have a maximum of 100 point voting score related to one specific voting event</li>
    </ul>
    </Typography>
    <Typography variant="body1" color="text.secondary"  fontWeight={'bold'} component={'div'} textAlign={'left'}>
    {'This demo of the Balanced Voting System contains the below modules:'}
    <br/><br/>
    <ul style={{textAlign: 'left'}}>
      <li><Button component={Link} target="_blank" to={'/votings'} size="small" >Voting pool (example)</Button> - Here voter can see upcoming actual/upcoming/closed votings</li>
      <li><Button component={Link} target="_blank" to={'/voting'} size="small" >Voting action screen (example)</Button> - Here is the view how an ongoing voting action interface look like</li>
      <li><Button component={Link} target="_blank" to={'/voting-topic'} size="small" >Voting info screen (example)</Button> - Here is an example view how a voter can read an actual voting</li>
      <li><Button component={Link} target="_blank" to={'/article'} size="small" >Article/critics (example)</Button> - This is an example article what will be assigned to votings by different authors</li>
    </ul>
    </Typography>
    <Typography variant="body1" color="text.secondary"  fontWeight={'bold'} component={'div'} textAlign={'left'}>
      {'This voting model concept is completely free to use. Me the author and the creator of this idea declare that I waive all my copyright.'}
      <br/><br/>
      <Button component={Link} target="_blank" to={'https://github.com/Martines90/balanced-voting-system'} size="small" >GITHUB repo</Button>
      </Typography>


    <Typography variant="body1" color="text.secondary"  fontWeight={'bold'} component={'div'} textAlign={'left'}>
    {'Contact me:'}&nbsp;
    <span style={{color: 'blue', fontWeight: 'bold'}}>{'hmartonsandor@gmail.com'}</span>
    </Typography>

    </Stack>
  );
}

// Default export
export default HomePage;
